/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_BrickInputs */

const cs_enum_brick = /** @type {(inputs: Enum_BrickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cihla`)
};

const en_enum_brick = /** @type {(inputs: Enum_BrickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brick`)
};

/**
* | output |
* | --- |
* | "Brick" |
*
* @param {Enum_BrickInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_brick = /** @type {((inputs?: Enum_BrickInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_BrickInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_brick(inputs)
	return cs_enum_brick(inputs)
});